/**
 * 本地 MCP server，安装/信息缓存
 * TODO: 未考虑页面生命周期内 server 卸载的情况
 */
import { HelperCore } from "@/common/dependencies";
import client from "./client";

class Store {
  mcpCache = {};          // 已获取的 MCP 信息
  mcpInstallCache = {};   // 已安装的 MCP

  constructor () {
    if(!HelperCore.IS_PROD){
      window._clientMcp = this;
    }
  }

  setMcpCache (serverName, mcpInfo) {
    // 页面生命周期内，有可能 mcp server 被回收
    return;

    this.mcpCache[serverName] = mcpInfo;
  }
  batchMcpCache (list) {
    if(!list?.length){
      return;
    }
    list.forEach(item => {
      this.setMcpCache(item.server_name, item);
    });
  }
  /**
   * 用于 chat 接口传 mcp 参数
   * @param {Array} serverNames 
   * @returns 
   */
  getMcpInfos = async (serverNames) => {
    if(!serverNames?.length){
      return {};
    }

    const resMcp = [];
    const remainServerName = [];
    serverNames.forEach(serverName => {
      if(this.mcpCache[serverName]){
        resMcp.push(this.mcpCache[serverName])
      }
      else {
        remainServerName.push(serverName);
      }
    });

    if(!remainServerName.length){
      return resMcp;
    }

    let needInstallServerNames = remainServerName.filter(serverName => !this.mcpInstallCache[serverName]);
    if(needInstallServerNames.length){
      try{
        const statusRes = await client.proxyRequestAsyncWithTimeout("McpQuery", {
          api : `/api/server/status`,
          method : 0,
          timeout : 1000, 
          param : {
            server_names : remainServerName,
          }
        }, "", "360Mcp");
        const serverList = JSON.parse(statusRes.data).data;
        serverList.forEach(item => {
          if(item.installed){
            needInstallServerNames = needInstallServerNames.filter(_ => _ != item.server_name);
            this.setMcpInstallCache(item.server_name);
          }
        });
      } catch(e){
        console.error(`/api/server/status`, e);
      }
    }

    if(needInstallServerNames.length){
      try{
        await Promise.all(needInstallServerNames.map(serverName => {
          if(this.mcpInstallCache[serverName]){
            return Promise.resolve();
          }

          return client.proxyRequestAsyncWithTimeout("McpQuery", {
            api : "/api/server/install/batch",
            method : 0,
            timeout : 60000, 
            param : {
              server_name : serverName,
            }
          }, "", "360Mcp", 2)
          .then(res => {
            try{
              const { code, data } = JSON.parse(res.data);
              if(code != 0){
                
              }
              else {
                data.forEach(item => {
                  if(item.installed){
                    this.setMcpInstallCache(item.server_name);
                  }
                })
              }
            } catch(e){}
          });
        }))
      } catch(e){
        console.error(`/api/server/install/batch error`, e);
      }
    }

    try{
      const params = {
        api : "/api/tools/batch", 
        method : 0,
        timeout : 3000,
        param : {
          server_names : remainServerName,
        },
      }

      const res = await client.proxyRequestAsyncWithTimeout("McpQuery", params, "", "360Mcp");
      const {
        data,
      } = res;
      const result = JSON.parse(data);
      const mcp = result.data;
      if(mcp && Array.isArray(mcp)){
        this.batchMcpCache(mcp);
        return [...resMcp, ...mcp];
      }
    } catch(e){
      console.error(`/api/tools/batch error`, e);
    }

    return resMcp;
  }

  setMcpInstallCache (serverName, installed = true) {
    // 页面生命周期内，有可能 mcp server 被回收
    return;
    
    this.mcpInstallCache[serverName] = installed;
  } 
}

const clientMcp = new Store();
export default clientMcp;